module.exports = __webpack_public_path__ + "assets/img/workspace_14.d5bdeeda.jpg";